import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Directive({
  selector: '[diVudDropdown]',
  exportAs: 'diVudDropdown',
  standalone: true,
  host: {
    '[class.open]': 'isOpen',
  },
})
export class VudDropdownDirective {
  private readonly elementRef = inject(ElementRef);
  private readonly isOpenSubject = new BehaviorSubject<boolean>(false);
  readonly isOpen$ = this.isOpenSubject.asObservable();

  @Input() closeOnOutsideClick = true;

  get isOpen(): boolean {
    return this.isOpenSubject.value;
  }

  open(): void {
    this.isOpenSubject.next(true);
  }

  close(): void {
    this.isOpenSubject.next(false);
  }

  toggle(): void {
    this.isOpenSubject.next(!this.isOpen);
  }

  @HostListener('document:click', ['$event.target'])
  onDocumentClick(target: EventTarget | null): void {
    if (!this.closeOnOutsideClick || !this.isOpen || !(target instanceof HTMLElement)) {
      return;
    }

    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (!clickedInside) {
      this.close();
    }
  }
}
